import React, { useState } from 'react';
import classnames from 'classnames';
import { CategoryBreadcrumbs } from 'src/types/global-types';
import { useViewport } from 'src/hooks/useViewport';
import { Breadcrumbs } from 'src/components/Breadcrumbs/Breadcrumbs';

import { RichText } from '../RichText/RichText';
import { Button } from '../Button/Button';

import classes from './CategoryHeader.scss';

type Props = {
    title: string;
    description?: string | null;
    breadcrumbs?: CategoryBreadcrumbs;
    onRemoveAll?: () => void;
    filtersSelected?: boolean;
    breadcrumbLabel?: string;
    urlKey?: string;
};

export const CategoryHeader: React.FunctionComponent<Props> = ({
    title,
    description,
    breadcrumbs,
    onRemoveAll,
    filtersSelected,
    breadcrumbLabel,
    urlKey,
}) => {
    const { isMobile } = useViewport();
    const maxLengthOfDescription = isMobile ? 250 : 500;

    const isLongDescription = description && description.length > maxLengthOfDescription;
    const [readMore, setReadMore] = useState(false);

    return (
        <div className={classes.categoryHeader}>
            {breadcrumbs && (
                <Breadcrumbs
                    category={breadcrumbs?.categoryName}
                    subcategory={breadcrumbs?.subcategoryName}
                    categoryUrl={breadcrumbs?.categoryUrl}
                    categoryBreadCrumbLabel={breadcrumbs?.breadcrumbLabel}
                    breadcrumbLabel={breadcrumbLabel}
                    urlKey={urlKey}
                />
            )}
            {onRemoveAll && filtersSelected && (
                <span className={classes.filterClear} onClick={onRemoveAll}>
                    Clear filters
                </span>
            )}
            {/* {title && treatment === 'on' && (
                <h1 itemProp="name" className={classes.pageTitle}>
                    {title}
                </h1>
            )} */}

            {description && (
                <>
                    <div
                        className={classnames(classes.categoryHeaderDescription, {
                            [classes.categoryHeaderDescriptionActive]: readMore,
                            [classes.categoryHeaderDescriptionLong]: isLongDescription,
                        })}
                    >
                        <RichText content={description} />
                        {isLongDescription && !readMore && <div className={classes.shade} />}
                    </div>
                    {isLongDescription && (
                        <Button
                            className={classes.categoryHeaderButton}
                            onClick={() => setReadMore(!readMore)}
                            variant="reset"
                        >
                            {readMore ? 'Read Less' : 'Read More'}
                        </Button>
                    )}
                </>
            )}
        </div>
    );
};
